import { Divider, Typography } from 'antd';

import {
  useRecordPayment,
  useRecordPaymentEffects,
} from '@app/components/RecordModal/components/RecordPayment/hooks';
import {
  Payments,
  ServicesTable,
  FinancialOperations,
  LoyaltyCards,
  PaymentModal,
  PrepaymentModal,
  YooKassaPayment,
  YookassaPaymentWithEmailModal,
} from '@app/components/RecordModal/components/RecordPayment/ui';
import type { ContentPropsType } from '@app/components/RecordModal/types';
import { PaymentInfoModal } from '@app/pages/Clients/ClientPayments/ClientPaymentsList/components';

import '@app/components/RecordModal/components/RecordPayment/styles/RecordPayment.desktop.scss';

const PF = 'record-payment';
const { Title } = Typography;

export const RecordPayment: ContentPropsType = () => {
  const {
    servicesTableData,
    initTable,
    printPdfFile,
    isPrintPdfLoading,
    totalAmount,
    onChangeAmount,
    selectedAmount,
    paymentModalAmount,
    paymentButtonsOptions,
    isPayFormBalanceButtonDisabled,
    handleOptionClick,
    Balance,
    paymentModalType,
    isPaymentModalOpen,
    isPrepaymentDialogOpen,
    setPrepaymentDialogOpen,
    receiptId,
    setPrepaymentLoader,
    prepaymentLoader,
    clientBalanceData,
    record,
    handlePaymentModalOk,
    prepayRecordHandler,
    totalPaid,
    fetchPayments,
    isDeletePaymentLoading,
    hasPayments,
    payments,
    acquiringPaymentMethodNames,
    fetchAcquiringPaymentMethodNames,
    hasUserRightToDeleteSale,
    isOpenConfirmationDialog,
    startPaymentDeletion,
    closeDeletePaymentModal,
    openDeletePeymentModal,
    recordId,
    paymentDate,
    setPaymentDate,
    paymentComment,
    setPaymentComment,
    setIsYooKassaModalOpen,
    isYooKassaModalOpen,
    handledYooKassaPaymentId,
    subscribeToAcquiringPaymentUpdateWsEvent,
    acquiringPaymentMethods,
    loyaltyCards,
    cardBonusesInfo,
    initialCardSearchHandler,
    setLoyaltyCards,
    paymentInfoModalOpen,
    setPaymentInfoModalOpen,
    objectId,
    setObjectId,
    handlePaymentInfoModalOpen,
    accessToPaymentWithLoyaltyCardBonuses,
    isPayFormYooKassaButtonDisabled,
    getRecordInfoHandler,
    yooKassaPaymentMethodCode,
    cancelPaymentModal,
    hasOrganizationRightToLoyalty,
    calculateBonusesToEarn,
    setCurrentCard,
    isYookassaPaymentWithEmailModalOpen,
    setIsYookassaPaymentWithEmailModalOpen,
    yookassaPaymentLinkParams,
    setYookassaPaymentLinkParams,
    handlePayByYouKassa,
    isNeedToCreateYooKassaPayment,
    setIsNeedToCreateYooKassaPayment,
    setUseEmailForPayment,
  } = useRecordPayment();

  useRecordPaymentEffects({
    initTable,
    fetchPayments,
    fetchAcquiringPaymentMethodNames,
    subscribeToAcquiringPaymentUpdateWsEvent,
    initialCardSearchHandler,
  });

  return (
    <>
      <div className={`${PF}__container`}>
        <Title className={`${PF}__title`} level={4} data-testid="payment-title">
          Оплата визита
        </Title>
        <div className={`${PF}__content`}>
          <ServicesTable
            data={servicesTableData}
            isPrintPdfLoading={isPrintPdfLoading}
            printPdfFile={printPdfFile}
          />
          <Divider className="blocks-divider" />
          {accessToPaymentWithLoyaltyCardBonuses &&
            hasOrganizationRightToLoyalty && (
              <LoyaltyCards
                loyaltyCards={loyaltyCards}
                cardBonusesInfo={cardBonusesInfo}
                setLoyaltyCards={setLoyaltyCards}
                recordId={recordId ?? 0}
                servicesTableData={servicesTableData}
                getRecordInfoHandler={getRecordInfoHandler}
                totalPaid={totalPaid}
                initTable={initTable}
                fetchPayments={fetchPayments}
                calculateBonusesToEarn={calculateBonusesToEarn}
                setCurrentCard={setCurrentCard}
              />
            )}

          <Divider className="blocks-divider" />
          <FinancialOperations
            totalAmount={totalAmount.toLocaleString('ru-RU')}
            totalPaid={totalPaid}
            isDeletePaymentLoading={isDeletePaymentLoading}
            hasPayments={hasPayments}
            payments={payments}
            acquiringPaymentMethodNames={acquiringPaymentMethodNames}
            hasUserRightToDeleteSale={hasUserRightToDeleteSale}
            isOpenConfirmationDialog={isOpenConfirmationDialog}
            startPaymentDeletion={startPaymentDeletion}
            closeDeletePaymentModal={closeDeletePaymentModal}
            openDeletePeymentModal={openDeletePeymentModal}
            handlePaymentInfoModalOpen={handlePaymentInfoModalOpen}
            handlePayByYouKassa={handlePayByYouKassa}
            setUseEmailForPayment={setUseEmailForPayment}
          />
          <Payments
            selectedAmount={selectedAmount}
            onChangeAmount={onChangeAmount}
            paymentButtonsOptions={paymentButtonsOptions}
            isPayFormBalanceButtonDisabled={isPayFormBalanceButtonDisabled}
            handleOptionClick={handleOptionClick}
            Balance={Balance}
            acquiringPaymentMethods={acquiringPaymentMethods}
            isPayFormYooKassaButtonDisabled={isPayFormYooKassaButtonDisabled}
          />
        </div>
      </div>
      <PaymentModal
        key="payment-modal"
        isPaymentModalOpen={isPaymentModalOpen}
        receiptId={receiptId}
        prepaymentLoader={prepaymentLoader}
        paymentAmount={paymentModalAmount}
        clientBalanceData={{
          Balance: clientBalanceData.Balance.toString(),
          ObjectId: clientBalanceData.ObjectId.toString(),
        }}
        totalAmount={totalAmount}
        paymentModalType={paymentModalType}
        recordDate={record?.TimeE}
        onOk={handlePaymentModalOk}
        onCancel={cancelPaymentModal}
        setPrepaymentLoader={setPrepaymentLoader}
        paymentDate={paymentDate}
        setPaymentDate={setPaymentDate}
        paymentComment={paymentComment}
        setPaymentComment={setPaymentComment}
        paymentMethod={yooKassaPaymentMethodCode}
        handlePayByYouKassa={handlePayByYouKassa}
      />

      <PrepaymentModal
        key="prepayment-modal"
        isPrepaymentDialogOpen={isPrepaymentDialogOpen}
        paymentAmount={selectedAmount}
        totalAmount={totalAmount}
        recordId={record?.Id ?? 0}
        receiptId={receiptId}
        onOk={prepayRecordHandler}
        onCancel={() => setPrepaymentDialogOpen(false)}
        recordDate={record?.TimeE}
      />

      <YooKassaPayment
        isModalOpen={isYooKassaModalOpen}
        clientId={record?.ClientId ?? 0}
        recordId={recordId ?? 0}
        paymentAmount={selectedAmount}
        paymentDate={paymentDate}
        paymentComment={paymentComment}
        setPaymentDate={setPaymentDate}
        setPaymentComment={setPaymentComment}
        setIsOpen={setIsYooKassaModalOpen}
        fetchPayments={fetchPayments}
        handledYooKassaPaymentId={handledYooKassaPaymentId}
        receiptId={receiptId}
        yooKassaPaymentMethodCode={yooKassaPaymentMethodCode}
        isNeedToCreateYooKassaPayment={isNeedToCreateYooKassaPayment}
      />

      <YookassaPaymentWithEmailModal
        isYookassaPaymentWithEmailModalOpen={
          isYookassaPaymentWithEmailModalOpen
        }
        setIsYookassaPaymentWithEmailModalOpen={
          setIsYookassaPaymentWithEmailModalOpen
        }
        yookassaPaymentLinkParams={yookassaPaymentLinkParams}
        setYookassaPaymentLinkParams={setYookassaPaymentLinkParams}
        fetchPayments={fetchPayments}
        setIsNeedToCreateYooKassaPayment={setIsNeedToCreateYooKassaPayment}
      />

      <PaymentInfoModal
        open={paymentInfoModalOpen}
        setOpen={setPaymentInfoModalOpen}
        objectId={objectId}
        setObjectId={setObjectId}
      />
    </>
  );
};
